import Request from '../../services/Requests.js';
import * as types from '../mutation-types'
import _ from 'lodash';

// state
export const state = {
    countries: [],
    regions: [],
    cities: []
};

// mutations
export const mutations = {
    [types.ADD_COUNTRIES](state, {countries}) {
        state.countries = countries;
    },

    [types.ADD_COUNTRY](state, {country}) {
        state.countries.push(country);
    },

    [types.ADD_REGIONS](state, {regions}) {
        state.regions = regions;
    },

    [types.ADD_REGION](state, {region}) {
        state.regions.push(region);
    },

    [types.ADD_CITIES](state, {cities}) {
        state.cities = cities;
    },

    [types.ADD_CITY](state, {city}) {
        state.cities.push(city);
    }
};

// actions
export const actions = {
    /**
     *
     * @param commit
     * @return {Promise<void>}
     */
    async parseCountryJson({commit}) {
        // Если стор уже заполнен
        if (state.countries.length > 0) {
            return new Promise((resolve) => {
                setTimeout(() => resolve('Countries have been retrieving already'), 20);
            });
        }

        return (new Request()).get('/libraries/location')
            .then(response => {
                if (response.isSuccess()) {
                    let data = response.getData();
                    _.forEach(data, country => {
                        _.forEach(country.regions.data, region => {
                            _.forEach(region.cities.data, city => {
                                commit(types.ADD_CITY, {city: city});
                            });

                            delete region.cities;

                            let exist = _.some(state.regions, item => {
                                return item.id === region.id;
                            });

                            if (exist === false) {
                                commit(types.ADD_REGION, {region: region});
                            }
                        });

                        delete country.regions;

                        let exist = _.some(state.countries, item => {
                            return item.id === country.id;
                        });

                        if (exist === false) {
                            commit(types.ADD_COUNTRY, {country: country});
                        }
                    });

                } else {
                    //
                }
            });
    }
};

// getters
export const getters = {
    /**
     *
     * @param state
     * @return {Array|*}
     */
    getCountries: state => state.countries,

    /**
     *
     * @param state
     * @return {function(*)}
     */
    getRegionsByCountryCode: state => (code) => {
        if (_.isEmpty(code)) {
            return [];
        }

        return _.filter(state.regions, region => {
            return region.country_code === code;
        });
    },

    /**
     *
     * @param state
     * @return {function(*)}
     */
    getCitiesByRegionId: state => (regionId) => {
        if (!(regionId > 0)) {
            return [];
        }
        return _.filter(state.cities, city => {
            return city.region_id === regionId;
        })
    }

};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/locations.js